import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Gallery = () => {
  const { t } = useLanguage();
  const images = [
    {
      url: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/8tyxgp59_WhatsApp%20Image%202026-04-09%20at%2012.50.40.jpeg',
      title: 'Battle en action'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/tltd1h41_WhatsApp%20Image%202026-04-09%20at%2012.50.42.jpeg',
      title: 'Breakdance moves'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/j0wgqoff_WhatsApp%20Image%202026-04-09%20at%2012.51.01.jpeg',
      title: 'Équipes en compétition'
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-black">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          {/* Section Title */}
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              {t('gallery_title')}
            </h2>
            <div className="w-24 h-1 bg-red-500 mx-auto mb-6"></div>
            <p className="text-gray-400 text-lg">
              {t('gallery_subtitle')}
            </p>
          </div>

          {/* Gallery Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {images.map((image, index) => (
              <div
                key={index}
                className="group relative overflow-hidden rounded-lg aspect-square cursor-pointer"
              >
                {/* Image */}
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <h3 className="text-white font-bold text-xl">{image.title}</h3>
                  </div>
                </div>

                {/* Border Effect */}
                <div className="absolute inset-0 border-2 border-red-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>

          {/* Additional Info */}
          <div className="mt-16 text-center">
            <p className="text-gray-400 text-lg mb-6">
              {t('gallery_follow')}
            </p>
            <div className="flex justify-center gap-4">
              <a
                href="https://instagram.com/hdm_i_team"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-zinc-800 hover:bg-red-500 text-white px-6 py-3 rounded-lg transition-colors duration-300 font-medium"
              >
                {t('gallery_instagram')}
              </a>
              <a
                href="https://tiktok.com/@hdmi.team"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-zinc-800 hover:bg-red-500 text-white px-6 py-3 rounded-lg transition-colors duration-300 font-medium"
              >
                {t('gallery_tiktok')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Gallery;
